module.exports = __webpack_public_path__ + "img/plant-in-rocks.5213b19a.jpg";